import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {AirlineService} from '../services/airline/airline.service';
import {BreadCrumbAndDataResolverService} from '../../utilities/services/route-resolvers/bread-crumb-and-data-resolver.service';
import {Airline} from '../interfaces/Airline';
import {BreadCrumbAndDataHelperService} from '../../utilities/services/route-resolvers/bread-crumb-and-data-helper.service';

@Injectable()
export class AirlineNameResolverService extends BreadCrumbAndDataResolverService<Airline> {

  constructor(private airlineService: AirlineService, helper: BreadCrumbAndDataHelperService) {
    super(helper);
  }

  public async getData(route: ActivatedRouteSnapshot): Promise<Airline> {
    return await this.airlineService.getAirline(Number(route.params.airlineId));
  }

  public getName(data: Airline): string {
    return data.name;
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/airline/resolvers/airline-name-resolver.service.ts